export default "__VITE_ASSET__CCaD3npG__"